import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminBookingOps = lazy(() => import("@/pages/admin/AdminBookingOps"));

export const Route = createFileRoute("/admin/bookings")({
  component: AdminBookingOps,
});
